import { USER_ROLES } from '../constants/roles';

// Where a visitor was heading when they were sent to sign in. Used by
// the pricing page's "Buy 1 Meeting": a signed-out visitor has to sign
// in or register first, and should land back on the purchase afterwards
// instead of on the dashboard.
//
// sessionStorage, so it never outlives the tab, and a short lifetime, so
// an abandoned sign-in cannot hijack a later one. Only in-app paths are
// ever stored or honoured - this is never an open redirect.
const POST_AUTH_KEY = 'copilot.postAuthPath';
const POST_AUTH_TTL_MS = 30 * 60 * 1000;

function isInAppPath(path) {
  return typeof path === 'string' && path.startsWith('/app/') && !path.startsWith('//');
}

export function rememberPostAuthPath(path) {
  if (!isInAppPath(path)) return;
  try {
    window.sessionStorage.setItem(POST_AUTH_KEY, JSON.stringify({ path, at: Date.now() }));
  } catch (_) {
    // Storage unavailable (private mode, quota): the user simply lands
    // on the normal home page after signing in.
  }
}

export function clearPostAuthPath() {
  try {
    window.sessionStorage.removeItem(POST_AUTH_KEY);
  } catch (_) {
    // Nothing to clear.
  }
}

function readPostAuthPath() {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(POST_AUTH_KEY) || 'null');
    if (!stored || !isInAppPath(stored.path)) return null;
    if (Date.now() - Number(stored.at) > POST_AUTH_TTL_MS) return null;
    return stored.path;
  } catch (_) {
    return null;
  }
}

// A plain read (it is called during render). The destination clears the
// remembered path itself once it has been reached - see PlansPage.
export function getAuthenticatedHomePath(user) {
  if (user?.role === USER_ROLES.ADMIN) return '/admin';
  return readPostAuthPath() || '/app';
}
